export default __webpack_public_path__ + "static/media/G.f072e365.svg";